import { GODIA_LOYALTY } from "@constants";
import { t } from "i18next";
import { useSnapshot } from "valtio";

import React from "react";
import { useSelector } from "react-redux";
import { Card } from "reactstrap";

import { formatCurrency } from "@helpers/general";

import { kioskStore as store } from "@pages/Kiosk/store";

export function LoyaltyConsommationCard(): JSX.Element {
    const {
        order: { totalPrice, orderFidelity },

        // eslint-disable-next-line
    } = useSelector((state: any) => state.orderSlice);
    const {
        customerLanguage,

        project: {
            fidelityType,
            template: { content },
        },
        user,
        orderTotalPrice,
    } = useSnapshot(store);

    const localMainContentItems = (
        content.loyaltyConsommation as ProjectContentItemType
    ).items;

    const godiaOrderFidelity = Math.round(totalPrice * user.pointRatio);

    const totalFidelity =
        fidelityType === GODIA_LOYALTY &&
        user.isCumulativeLoyaltyPointsOnTotalOrder
            ? godiaOrderFidelity
            : orderFidelity;

    return (
        <Card
            style={{
                width: "910px",
                borderRadius: "31px",
                borderBottom: "12px solid #D51B1B",
                boxShadow: "0px 3px 6px #00000029",
                fontFamily: "var(--font-primary)",
            }}
        >
            <div
                style={{
                    display: "grid",
                    gridTemplateRows:
                        "min-content min-content 1fr min-content min-content min-content min-content",
                    height: "100%",
                }}
            >
                <div
                    className="d-flex justify-content-between align-items-center mx-5 px-2"
                    style={{
                        fontSize: "var(--font-size-title)",
                        color: "var(--font-color-title)",
                        lineHeight: "128px",
                    }}
                >
                    {t("Left to pay")}

                    <div className="font-weight-bold">
                        {formatCurrency(orderTotalPrice)}
                    </div>
                </div>
                <hr
                    style={{
                        height: "2px",
                        width: "88%",
                        backgroundColor: "#AFAFAF",
                        border: "0px",
                    }}
                />

                <div
                    className="d-flex justify-content-between align-items-center mx-5 px-2"
                    style={{
                        fontWeight: 600,
                        fontSize: "var(--font-size-title)",
                        color: "var(--font-color-title)",
                        lineHeight: "60px",
                    }}
                >
                    {
                        (
                            localMainContentItems as ProjectMainContentItemType[]
                        )[1].languages[customerLanguage.name].name
                    }

                    <div>{formatCurrency(user.loyaltyAmount)}</div>
                </div>
                <hr
                    style={{
                        height: "2px",
                        width: "88%",
                        backgroundColor: "#AFAFAF",
                        border: "0px",
                    }}
                />
                <div
                    className="d-flex justify-content-between align-items-center mx-5 px-4"
                    style={{
                        fontSize: "var(--font-size-subtitle)",
                        lineHeight: "40px",
                        color: "#7C7C7C",
                    }}
                >
                    {
                        (
                            localMainContentItems as ProjectMainContentItemType[]
                        )[0].languages[customerLanguage.name].name
                    }

                    <div>{formatCurrency(totalPrice)}</div>
                </div>
                <div
                    className="d-flex justify-content-between align-items-center mx-5 px-4"
                    style={{
                        fontSize: "var(--font-size-subtitle)",
                        lineHeight: "40px",
                        color: "#7C7C7C",
                    }}
                >
                    {
                        (
                            localMainContentItems as ProjectMainContentItemType[]
                        )[2].languages[customerLanguage.name].name
                    }

                    <div>{`${totalFidelity} ${
                        totalFidelity <= 1 ? t("Point") : t("Points")
                    }`}</div>
                </div>
                <div
                    className="d-flex justify-content-between align-items-center mx-5 px-4 py-2"
                    style={{
                        fontSize: "var(--font-size-base)",
                        lineHeight: "20px",
                        color: "#7C7C7C",
                    }}
                >
                    {
                        (
                            localMainContentItems as ProjectMainContentItemType[]
                        )[3].languages[customerLanguage.name].name
                    }
                </div>
            </div>
        </Card>
    );
}
